/**
 * Protected food-log photo. Fetches the image as an authenticated blob
 * (the endpoint enforces authz server-side) and renders it; never exposes
 * a public URL. Revokes the object URL on unmount.
 */
import React, { useEffect, useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import foodLogService from '../../services/foodLogService';

const FoodLogPhoto = ({ entryId, alt = 'Foto de comida', height = 220, sx = {} }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    foodLogService
      .getPhotoObjectUrl(entryId)
      .then((u) => {
        objectUrl = u;
        if (!cancelled) setUrl(u);
        else URL.revokeObjectURL(u);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [entryId]);

  if (failed) {
    return (
      <Box
        sx={{
          height, display: 'flex', alignItems: 'center', justifyContent: 'center',
          bgcolor: 'grey.100', borderRadius: 2, color: 'grey.400', ...sx,
        }}
      >
        <RestaurantIcon sx={{ fontSize: 48 }} />
      </Box>
    );
  }
  if (!url) return <Skeleton variant="rounded" height={height} sx={sx} />;
  return (
    <Box
      component="img"
      src={url}
      alt={alt}
      sx={{
        width: '100%', height, objectFit: 'cover', borderRadius: 2,
        display: 'block', ...sx,
      }}
    />
  );
};

export default FoodLogPhoto;
